import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import type { ExtendedCmsInsuranceTypeContent } from '../../../types';

type MapArticleContentProps = {
  cmsSectionContent: ExtendedCmsInsuranceTypeContent['articles'] | undefined;
};

const mapArticlesContent = ({ cmsSectionContent }: MapArticleContentProps) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  return {
    articles: cmsSectionContent,
    type: CONTENT_SECTIONS.ARTICLES,
  };
};

export default mapArticlesContent;
